export default __webpack_public_path__ + "static/media/falcon-mode-default.953e5536.jpg";